import { render, staticRenderFns } from "./SyncLegoTable2.vue?vue&type=template&id=420ced74&scoped=true&"
import script from "./SyncLegoTable2.vue?vue&type=script&lang=ts&"
export * from "./SyncLegoTable2.vue?vue&type=script&lang=ts&"
import style0 from "./SyncLegoTable2.vue?vue&type=style&index=0&id=420ced74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ced74",
  null
  
)

export default component.exports